import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { HOME } from "../../routes";
import { Spinner, FloatingInput } from "../../Components/Common";
import { updateUser, getUser } from "../../Services/UserServices";
import { MESSAGES } from "./constants";

const validationSchema = Yup.object().shape({
  first_name: Yup.string().required(MESSAGES.FIRST_NAME_REQUIRED),
  last_name: Yup.string().required(MESSAGES.LAST_NAME_REQUIRED),
  mobile: Yup.string()
    .matches(/^\d{10}$/, MESSAGES.MOBILE_VALIDATION_MESSAGE)
    .required(MESSAGES.MOBILE_NUMBER_REQUIRED),
  email: Yup.string()
    .email(MESSAGES.INVALID_MAIL)
    .required(MESSAGES.MAIL_REQUIRED),
});

const Profile = () => {
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()

  const fetchUserData = async () => {
    try {
      const res = await getUser();

      if (res?.status === 200 && res.data) {
        setInitialValues({
          first_name: res.data.first_name || "",
          last_name: res.data.last_name || "",
          role: res.data.role || "",
          email: res.data.email || "",
          mobile: res.data.mobile || "",
        });
      } else {
        toast.error(MESSAGES.FAILED_FETCH_USER);
      }
    } catch (err) {
      toast.error(MESSAGES.ERROR_FETCH_USER);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      const response = await updateUser(values);
      if (response.status === 200 || response.status === 204) {
        toast.success(MESSAGES.UPDATE_USER);
        fetchUserData();
      } else {
        toast.error(MESSAGES.FAILED_UPDATE_USER);
      }
    } catch (error) {
      toast.error(MESSAGES.ERROR_UPDATE_USER);
    }
  };

  if (loading || !initialValues) {
    return (
      <div className="flex justify-center py-10">
        <Spinner size={4} />
      </div>
    );
  }

  return (
    <div className="">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, dirty }) => (
          <Form className="space-y-6 max-w-xl mx-auto px-6">
            <div className="flex justify-start items-center mt-6 gap-24 md:gap-44">
              <button
                type="button"
                onClick={() => navigate(HOME)}
                className="text-primary hover:text-secondary text-2xl"
                title="Back"
              >
                <HiOutlineArrowLeft />
              </button>
              <h2 className="text-3xl font-bold text-center text-primary">
                Profile
              </h2>
            </div>

            <FloatingInput name="first_name" label="First Name *" />
            <FloatingInput name="last_name" label="Last Name *" />
            <FloatingInput name="email" label="Email *" type="email" />
            <FloatingInput
              name="mobile"
              label="Mobile No. *"
              type="tel"
              disabled
            />
            <FloatingInput name="role" label="Role *" disabled />

            <div className="flex justify-end gap-4 pt-4">
              <button
                type="submit"
                disabled={!dirty || isSubmitting}
                className={`font-semibold py-1 px-6 rounded ${
                  !dirty || isSubmitting
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "bg-primary hover:bg-opacity-80 text-white"
                }`}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Profile;
